import React from 'react';
import PropTypes from 'prop-types';
import AntdBadge from 'antd/lib/badge';
import './style/index.less';

/**
 * 字体图标，兼容antd的图标
 */
class Badge extends React.Component {
  static propTypes = {
    count: PropTypes.number,
    overflowCount: PropTypes.number,
    offset: PropTypes.array,
  };

  static defaultProps = {
    prefixCls: 0,
    overflowCount: 99,
    offset: [6, 25],
  };

  render() {
    const {
      count,
      overflowCount,
      className,
      offset,
      children,
    } = this.props;
    if (!children) return null;
    return <AntdBadge count={count} overflowCount={overflowCount} offset={offset}>
      { children }
    </AntdBadge>
  }
}

export default Badge;



// WEBPACK FOOTER //
// ./src/components/Badge/Badge.js